import * as React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import Retracked from 'js/app/retracked';

type ImplProps = {
  trackingName: string;
  // Original propType: object
  data?: $TSFixMe;
  // Original propType: func
  dataFromEvent?: $TSFixMe;
  children?: React.ReactNode;
  elementType: 'div' | 'span';
  clickHandler?: (event: MouseEvent) => void;
};

class TrackedOnLinkClickImpl extends React.LegacyComponentWithChildren<ImplProps> {
  static contextTypes = {
    _eventData: PropTypes.object,
    _withTrackingData: PropTypes.func,
  };

  declare context: LegacyContextType<typeof TrackedOnLinkClickImpl.contextTypes>;

  trackClick = (e: $TSFixMe) => {
    if (e.target.tagName === 'A') {
      const { _eventData, _withTrackingData } = this.context;
      const { dataFromEvent: dataFromEventProp, data: dataProp, trackingName, clickHandler } = this.props;
      // some links might have a click event instead of the href attribute
      const { href } = e.target.attributes;
      const dataFromEvent = dataFromEventProp ? dataFromEventProp(e) : {};
      const data = {
        ...dataProp,
        ...dataFromEvent,
        href: href && href.value,
      };
      Retracked.trackComponent(_eventData, data, trackingName, 'click', _withTrackingData);

      if (clickHandler) {
        clickHandler(e);
      }
    }
  };

  render() {
    const { _eventData } = this.context;
    const { trackingName, elementType, children } = this.props;
    const namespace = (_eventData && _eventData.namespace) || {};
    const action = 'click';
    const { app, page } = namespace;
    const component = trackingName;
    const Element = elementType;

    return (
      <Element
        onClick={this.trackClick}
        data-track={true}
        data-track-app={app}
        data-track-page={page}
        data-track-action={action}
        data-track-component={component}
        {..._.omit(this.props, 'data', 'elementType', 'trackingName', 'clickHandler')}
      >
        {children}
      </Element>
    );
  }
}

type TrackedOnLinkClickProps = Omit<ImplProps, 'elementType'>;

class TrackedOnLinkClickDiv extends React.LegacyComponentWithChildren<TrackedOnLinkClickProps> {
  render() {
    return <TrackedOnLinkClickImpl elementType="div" {...this.props} />;
  }
}

class TrackedOnLinkClickSpan extends React.LegacyComponentWithChildren<TrackedOnLinkClickProps> {
  render() {
    return <TrackedOnLinkClickImpl elementType="span" {...this.props} />;
  }
}

export { TrackedOnLinkClickDiv, TrackedOnLinkClickSpan };
